import React from "react";
import { View, Text, TextInput, Button, Icon } from "ui";
import { ContactModal, DateModal } from "components";
import moment, { Moment } from "moment";
import {
  SERVER_TIME_FORMAT,
  TIME_FORMAT,
  DATE_FORMAT,
  SERVER_DATE_FORMAT
} from "shared/constants";
import { DataProps, Alert } from "types";
import _ from "lodash";
import { RouteComponentProps } from "react-router";
import { parse } from "query-string";
import DaysBefore from "./components/DaysBefore";
import { ContactItem } from "../../components/ContactModal";
import { alertMutations } from "api";
import { notify } from "shared/services";
import AlertHour from "./components/AlertHour";

import ConfirmDialog from "../../components/ConfirmDialog";

import { theme } from "styles";

interface AlertStateShape {
  id?: string;
  name?: string;
  memo_id: string;
  alert_template_id?: string;
  date: Moment;
  daysBefore: number;
  first_alert_time: Moment;
  second_alert_time: Moment;
  phones: ContactItem[];
  emails: ContactItem[];
  openDialog: boolean;
}
interface S {
  id?: string;
  name?: string;
  memo_id: string;
  alert_template_id?: string;
  date: Moment;
  first_alert_time: Moment;
  second_alert_time: Moment;
  phones: ContactItem[];
  emails: ContactItem[];
  checkedPhones: { [key: string]: boolean };
  checkedEmails: { [key: string]: boolean };
  daysBefore: number;
  openDialog?: boolean;
}
type P = DataProps & RouteComponentProps<{ alert_id: string }> & {fromAlerts?: boolean};
export default class AlertForm extends React.Component<P, S> {
  constructor(props: P) {
    super(props);
    const form = this.getStateVariables(props);
    const checkedPhones = _.zipObject(
      form.phones.map(p => p.key),
      _.map(form.phones, (p, i) => true)
    );
    const checkedEmails = _.zipObject(
      form.emails.map(p => p.key),
      _.map(form.emails, (e, i) => true)
    );
    this.state = {
      ...form,

      checkedPhones,
      checkedEmails
    };
  }
  public getStateVariables = (props: P) => {
    const id = props.match.params.alert_id;
    const search = parse(props.location.search);
    const memo_id = search.memo || undefined;
    const alert_template_id = search.template || undefined;
    const phones = props.currentUser.phones.filter(p => p.active);
    const emails = props.currentUser.emails.filter(e => e.active);
    let form: AlertStateShape = {
      id: undefined,
      name: "",
      memo_id,
      alert_template_id,
      daysBefore: 7,
      date: moment().add(8, "d"),
      first_alert_time: moment("10:00", "HH:mm"),
      second_alert_time: moment("14:00", "HH:mm"),
      openDialog: false,

      phones: phones.length
        ? phones.map(p => ({
          key: p.id,
          label: p.phone_number
        }))
        : [],
      emails: emails.length
        ? emails.map(e => ({
          key: e.id,
          label: e.email
        }))
        : []
    };
    if (id) {
      const {
        disabled,
        start_date,
        end_date,
        first_alert_time,
        second_alert_time,
        phones: alertPhones,
        emails: alertEmails,
        ...alert
      } = props.findAlertById(id);

      form = {
        ...alert,
        openDialog: false,
        phones: phones
          .map(p => ({
            key: p.id,
            label: p.phone_number
          })),
        emails: emails.map(p => ({
          key: p.id,
          label: p.email
        })),
        daysBefore: moment(end_date, DATE_FORMAT).diff(
          moment(start_date, DATE_FORMAT),
          "d"
        ),
        date: moment(end_date, DATE_FORMAT),
        first_alert_time: moment
          .utc(first_alert_time, SERVER_TIME_FORMAT)
          .local(false),
        second_alert_time: moment
          .utc(second_alert_time, SERVER_TIME_FORMAT)
          .local(false)
      };
    }

    return form;
  }

  public getMutationVariables = () => {
    const {
      id,
      name,
      memo_id,
      alert_template_id,
      date,
      daysBefore,
      first_alert_time,
      second_alert_time,
      phones,
      emails,
      checkedPhones,
      checkedEmails,
      openDialog
    } = this.state;

    let alert: alertMutations.UpsertAlertArgs = {
      id,
      name,
      memo_id,
      alert_template_id,
      start_date: date
        .clone()
        .subtract(daysBefore, "d")
        .utc(false)
        .format(SERVER_DATE_FORMAT),
      end_date: date
        .clone()
        .utc(false)
        .format(SERVER_DATE_FORMAT),
      first_alert_time: first_alert_time.format(SERVER_TIME_FORMAT),
      second_alert_time: second_alert_time.format(SERVER_TIME_FORMAT),
      phones: Object.entries(checkedPhones)
        .filter(e => e[1])
        .map(e => e[0]),
      emails: Object.entries(checkedEmails)
        .filter(e => e[1])
        .map(e => e[0])
    };
    return alert;
  }
  public handleNameChange = e => this.setState({ name: e.target.value });
  public handleDateChange = (date: Moment) => {
    let { daysBefore } = this.state;
    if (date.diff(moment(), "d") < this.state.daysBefore) {
      daysBefore = date.diff(moment(), "d");
    }
    this.setState({ date, daysBefore });
  }
  public handleDaysBefore = (daysBefore: number) =>
    this.setState({ daysBefore })

  public handleFirstTime = (first_alert_time: Moment) =>
    this.setState({ first_alert_time })
  public handleSecondTime = (second_alert_time: Moment) =>
    this.setState({ second_alert_time })

  public handlePhonesClose = checkedPhones => this.setState({ checkedPhones });
  public handleEmailsClose = checkedEmails => this.setState({ checkedEmails });

  public deleteItem = () => {
    const { openDialog } = this.state;
    return (
      <alertMutations.DeleteAlert>
        {deleteAlert => (
          <ConfirmDialog
            text="Esti sigur ca vrei sa stergi alerta?"
            open={openDialog}
            onClose={() => this.setState({ openDialog: false })}
            onConfirm={async () => {
              try {
                if (!this.props.currentUser.subscribed) {
                  notify(
                    "Ai nevoie de un abonament activ pentru a sterge alerte"
                  );
                  this.props.history.push("/app/abonament");
                  return;
                }
                const variables = this.getMutationVariables();
                await deleteAlert({
                  variables: { id: variables.id }
                });
                notify("Alerta a fost stearsa!");
                if (this.props.fromAlerts){
                  this.props.history.replace(`/app/alerts`);
                } else {
                  this.props.history.replace(`/app/memos/${variables.memo_id}`);
                }

              } catch (error) {}
            }}
          />
        )}
      </alertMutations.DeleteAlert>
    );
  }

  public handleCloseClick = () => {
    const { history, fromAlerts } = this.props;
    const { memo_id } = this.state;
    if (fromAlerts){
      history.push(`/app/alerts`);
    } else {
      history.push(`/app/memos/${memo_id}`);
    }
  }

  public render = () => {
    const {
      name,
      date,
      daysBefore,
      first_alert_time,
      second_alert_time,
      phones,
      emails,
      checkedPhones,
      checkedEmails,
      memo_id,
      alert_template_id,
      openDialog
    } = this.state;
    const { findMemoById, findTemplateById } = this.props;
    const memo = findMemoById(memo_id) || {};
    const template = findTemplateById(alert_template_id);

    let maxDays;
    if (date.diff(moment(), "d") >= 0) {
      maxDays = Math.min(date.diff(moment(), "d"), 14);
    } else {
      maxDays = 7;
    }

    return (
      <View flexDirection="column" pl={2} pr={2}>
        <View flexDirection="row" justifyContent="flex-end">
          <View onClick={this.handleCloseClick}>
          <Icon style={{ cursor: "pointer" }} color={theme.colors.primary} size={2} name="close" />
          </View>
        </View>

        <Text mt={2} fontSize={3}>
          Memo
        </Text>
        <View
          bg="black"
          borderRadius={10}
          justifyContent="center"
          alignItems="center"
          p={2}
        >
          <Text color="white" textAlign="center" fontSize={3}>
            {(memo as any).name}
          </Text>
        </View>

        <Text mt={2} fontSize={3}>
          Nume Alerta{" "}
        </Text>

        {template ? (
          <TextInput
            height="2rem"
            disabled
            fontSize={3}
            style={{ textAlign: "center" }}
            value={template.name}
          />
        ) : (
          <TextInput
            height="2rem"
            fontSize={3}
            value={name}
            style={{ textAlign: "center" }}
            onChange={this.handleNameChange}
          />
        )}

        <Text mt={2} fontSize={3}>
          Configureaza Alerta
        </Text>

        <DateModal
          date={date}
          title="Data Alerta"
          leftIcon="calendar"
          onChange={this.handleDateChange}
          minDate={moment().add(2, "d")}
        />
        <DaysBefore
          title="Cu cate zile inainte"
          days={daysBefore}
          onChange={this.handleDaysBefore}
          maxDays={maxDays}
        />
        <AlertHour
          title="Prima ora de alertare"
          time={first_alert_time}
          onChange={this.handleFirstTime}
        />
        <AlertHour
          title="A doua ora de alertare"
          time={second_alert_time}
          onChange={this.handleSecondTime}
        />

        <Text mt={2} fontSize={4}>
          Alerta pe:
        </Text>
        {phones.length > 0 && (
          <ContactModal
            contacts={phones}
            selectedContacts={checkedPhones}
            title="Telefon"
            leftIcon="phone"
            onClose={this.handlePhonesClose}
          />
        )}
        {emails.length > 0 && (
          <ContactModal
            title="Email"
            contacts={emails}
            selectedContacts={checkedEmails}
            leftIcon="email"
            onClose={this.handleEmailsClose}
          />
        )}

        <View mt={3} mb={3} flexDirection="row">
          <Button
            mr={4}
            p={2}
            bg="warning"
            flex={1}
            onClick={() => this.setState({ openDialog: true })}
          >
            <Text color="white" fontSize={3}>
              Sterge
            </Text>
          </Button>
          {openDialog && this.deleteItem()}
          <alertMutations.UpsertAlert>
            {upsert => (
              <Button
                p={2}
                flex={1}
                // as={NavLink}
                // to="memos/:id"
                onClick={async () => {
                  try {
                    if (!this.props.currentUser.subscribed) {
                      notify(
                        "Ai nevoie de un abonament activ pentru a creea sau edita alerte"
                      );
                      this.props.history.push("/app/abonament");
                      return;
                    }
                    const variables = this.getMutationVariables();
                    const res = await upsert({ variables });
                    if (res && res.data) {
                      if (!variables.id) {
                        this.props.history.replace(
                          `/app/memos/${res.data.upsertAlert.memo_id}/alert/${
                            res.data.upsertAlert.id
                          }`
                        );
                        notify("Alerta a fost creata");
                      } else {
                        // this.props.history.replace(
                        //   `/app/memos / $;{res.data.upsertAlert.memo_id;}`
                        // );
                        notify("Alerta a fost editata");
                      }
                    }
                  } catch (error) {}
                }}
              >
                <Text color="white" fontSize={3}>
                  Salveaza
                </Text>
              </Button>
            )}
          </alertMutations.UpsertAlert>
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/main/AlertForm.tsx